import "@/liberti.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { trackVisit } from "@/lib/api";
import Landing from "@/pages/Landing";
import Agendar from "@/pages/Agendar";
import Login from "@/pages/Login";
import Campus from "@/pages/Campus";
import Checkout from "@/pages/Checkout";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import Verificar from "@/pages/Verificar";
import CookieBanner from "@/components/CookieBanner";
import InstallPrompt from "@/components/InstallPrompt";
import UploadProgress from "@/components/UploadProgress";
import { initAnalytics, trackPageView } from "@/lib/analytics";
import ErrorBoundary from "@/components/ErrorBoundary";

function getVisitorId() {
  try {
    let vid = localStorage.getItem("lci_vid");
    if (!vid) {
      vid = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
      localStorage.setItem("lci_vid", vid);
    }
    return vid;
  } catch {
    return "anon";
  }
}

function RouteTracker() {
  const location = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => {
    const path = location.pathname;
    trackPageView(path);
    if (path.startsWith("/admin")) return; // no rastrear el panel interno
    trackVisit({ path, visitor_id: getVisitorId(), referrer: document.referrer || "" });
  }, [location.pathname]);
  return null;
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="lci" style={{ display: "grid", placeItems: "center", minHeight: "100vh", color: "var(--muted)" }}>Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <Toaster theme="dark" position="top-center" richColors />
            <CookieBanner />
            <InstallPrompt />
            <UploadProgress />
            <RouteTracker />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/agendar" element={<Agendar />} />
              <Route path="/login" element={<Login />} />
              <Route path="/campus" element={<Protected><Campus /></Protected>} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/admin" element={<Protected><Admin /></Protected>} />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="/verificar/:code" element={<Verificar />} />
              <Route path="/verificar" element={<Verificar />} />
            </Routes>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
